export const getDateEditorStyle = () => ({
  form: {
    fontSize: '14px !important',
    '& .error': {
      color: '#a80000',
    },
    '& .campaigns-date-picker': {
      '& .radioInput': {
        width: 'auto',
        '& .date + div': {
          width: '8em',
        },
        '& input[type="radio"]': {
          marginRight: '7.5px',
          outline: 'none !important',
          position: 'relative',
          marginLeft: '2px',
          '&:focus': {
            outline: '1px solid #605e5c !important',
          },
        },
        '& label': {
          display: 'inline-block',
          top: '-5px',
          position: 'relative',
          margin: '0 2px',
          fontWeight: '400',
        },
      },
    },
  },
});
